import React, { Fragment } from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CheckMarkIcon } from '../../../../../../resources/assets/components/DLS_Checkmark.svg';
import { Text } from '../../../../text/text.js';
import './wizard-sidebar-step.css';
function WizardSidebarStep(props) {
    const displayValue = props.parentGroupDisplayIndex
        ? `${props.parentGroupDisplayIndex}.${props.displayIndex}`
        : props.displayIndex;
    const barStepClassName = classNames({
        'c-wizard-sidebar-step': true,
        'c-wizard-sidebar-step--current': props.currentStep,
        'c-wizard-sidebar-step--disabled': !props.enabled && !props.readOnly,
        'c-wizard-sidebar-step--done': props.done || props.readOnly,
        'c-wizard-sidebar-step--read-only': props.readOnly,
        't-color-signal-green': true,
    });
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: barStepClassName, "data-wizard-step-identifier": props.identifier },
            React.createElement("div", { className: "c-wizard-sidebar-step__header" },
                React.createElement("div", { className: "c-wizard-sidebar-step__header-index" }, !props.readOnly && props.done
                    ? React.createElement(CheckMarkIcon, { className: "c-wizard-sidebar-step__header-checkmark" })
                    : displayValue),
                React.createElement("div", { className: "c-wizard-sidebar-step__header-text" },
                    React.createElement(Text, { className: "c-wizard-sidebar-step__header-title", ellipsis: true, value: props.title }),
                    React.createElement(Text, { className: "c-wizard-sidebar-step__header-subtitle", ellipsis: true, value: props.subtitle })))),
        props.showSeparator ? React.createElement("div", { className: "c-wizard-sidebar-step__separator" }) : null));
}
export { WizardSidebarStep, };
//# sourceMappingURL=wizard-sidebar-step.js.map